module.exports = __webpack_public_path__ + "media/images/core_values/courage-8b47de5c345dff6800eea4e9d1b2474a.png";